<template>
    <div
        class="mobile:p-4 tablet:p-4 mobile:mx-1 mobile:my-2 tablet:my-3 tablet:mx-4 flex flex-col justify-start items-start gap-2 rounded-2xl shadow-[0px_0px_10px_0px_#00000026;] bg-white"
>
        <!-- card header -->
        <div class="relative w-full">
            <div
                class="relative flex flex-col justify-center rounded-lg overflow-hidden mobile:h-[100px] tablet:h-[120px] largeDesktop:h-[130px] px-3 w-full"
>
                <div class="absolute left-0 top-0 w-full h-full z-10">
                    <img
src="../../assets/images/profile-bg.png" alt="Background"
                        class="w-full mobile:h-full tablet:h-full object-cover"
>
                </div>
                <div class="flex justify-between items-center relative z-20 w-full">
                    <div class="flex justify-start items-center gap-1">
                        <div class="w-1.5 h-1.5 rounded-full bg-purple-100" />
                        <div class="w-6 h-1.5 rounded-full bg-purple-100" />
                        <p class="mobile:text-base tablet:text-lg font-bold font-roboto pl-2 m-0 text-purple-100">
New Plan
</p>
                    </div>
                    <div
                        class="w-fit text-xs largeDesktop:text-sm font-normal px-2.5 largeDesktop:px-3 rounded-full shadow-[0px_0px_10px_0px_#00000026;] text-purple-100 bg-white"
>
                        {{ plan.trade_name }}
                    </div>
                </div>
                <div class="w-full flex items-center gap-2 relative z-20">
                    <h4
                        class="text-left mobile:text-sm mobile:leading-tight tablet:leading-none tablet:text-lg largeDesktop:text-xl !font-normal font-roboto mb-0 text-black-100"
>
                        {{ plan.plan_name }}
</h4>
                </div>
            </div>
        </div>

        <div class="ml-[0.5rem] text-left">
            <h4 class="font-roboto mobile:text-[16px] tablet:text-[20px] m-0 text-red-500">
                {{ plan.months + ' months plan' }}
</h4>
            <h2 v-if="plan.is_show_amount == 1" class="font-roboto mobile:text-[20px] tablet:text-[40px] font-bold text-gray-900">
${{
                $helper.formatAmount(plan.amount) }}<span class="text-xl">/mo</span>
</h2>
        </div>
        <div class="py-1 ml-[0.5rem]">
            <div class="w-full h-auto m-0 bundleDescription" v-html="plan.description" />
        </div>
        <customAccordion :key="modalKey" :items="accordionData" />
        <div
v-if="plan.terms_and_conditions && plan.terms_and_conditions.length > 0"
            class="w-full ml-[0.5rem] my-[0.7rem] group rounded-[10px] border-[1px] transition duration-300 border-[#A084E8] hover:bg-[#A084E8] [@media(max-width:1023px)]:!bg-[#A084E8]"
>
            <a
:href="plan.terms_and_conditions" target="_blank" rel="noopener" class="block no-underline w-full text-center text-[16px] font-roboto font-medium px-1 py-1.5 cursor-pointer text-[#9336B4] group-hover:text-white [@media(max-width:1023px)]:!text-white transition duration-300 
            "
>Terms & Conditions</a>
        </div>
    </div>
</template>


<script>
import customAccordion from '../partialComponent/customAccordion.vue';
export default {
    components: {
        customAccordion,
    },
    props: {
        plan: Object,
        isSelected: Boolean,
        modalKey: Number,
    },

    data() {
        return {
        };
    },

    computed: {
        accordionData() {
            let arr = []

            if (this.plan.covered && this.plan.covered.length > 0) {
                arr.push({
                    title: "What's covered:",
                    content: this.plan.covered,
                    class: 'bundleDescription'
                })
            }

            if (this.plan.unit_quantity && this.plan.unit_quantity.length > 0) {
                arr.push({
                    title: "Unit quantity: Why do I need more?",
                    content: this.plan.unit_quantity,
                    class: 'bundleDescription'
                })
            }

            if (this.plan.not_covered && this.plan.not_covered.length > 0) {
                arr.push({
                    title: "What's not covered:",
                    content: this.plan.not_covered,
                    class: 'bundleDescription'
                })
            }

            if (this.plan.limitations && this.plan.limitations.length > 0) {
                arr.push({
                    title: "Limitations:",
                    content: this.plan.limitations,
                    class: 'bundleDescription'
                })
            }
            return arr
        }
    },
}
</script>
<style>
.bundleDescription ul {
    padding: 0;
    text-align: left;
    font-family: 'Lato' !important;
}

.bundleDescription ul li {
    padding-left: 2rem;
    position: relative;
    font-size: 16px !important;
    font-weight: 400 !important;
    font-family: 'Lato' !important;
    color: #333333 !important;
}

.bundleDescription ul li:after {
    position: absolute;
    content: "";
    top: 2px;
    left: 0;
    background-image: url('../../assets/images/double-check-pruple.png');
    background-position: center;
    background-size: contain;
    width: 22px;
    height: 22px;
}

.bundleDescription p a,
.bundleDescription a {
    color: #A084E8;
}

.bundleDescription ul li span,
.bundleDescription p span {
    font-size: 16px !important;
    font-family: 'Lato' !important;
}
.bundleDescription p {
    font-size: 16px !important;
    font-family: 'Lato';
    text-align: left !important;
    margin-bottom: 10px;
    color: #333333;
}
</style>
